import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import StatsCard from '../components/StatsCard';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import { API_ENDPOINTS } from '../config';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

import CanvasJSReact from '@canvasjs/react-charts';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalAppointments: 0,
    totalOrders: 0,
    totalProviders: 0,
  }); 

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [providersRes, appointmentsRes, ordersRes, usersRes] = await Promise.all([
          axios.get(API_ENDPOINTS.countProviderBusinesses),
          axios.get(API_ENDPOINTS.countAppointments),
          axios.get(API_ENDPOINTS.countOrders),
          axios.get(API_ENDPOINTS.countUsers),
        ]);

        setStats({
          totalProviders: providersRes.data.count || 0,
          totalAppointments: appointmentsRes.data.count || 0,
          totalOrders: ordersRes.data.count || 0,
          totalUsers: usersRes.data.count || 0,
        });

        setChartData({
          labels: ['Users', 'Appointments', 'Orders', 'Providers'],
          datasets: [
            {
              label: 'Counts',
              data: [
                usersRes.data.count || 0,
                appointmentsRes.data.count || 0,
                ordersRes.data.count || 0,
                providersRes.data.count || 0,
              ],
              borderColor: 'rgba(75, 192, 192, 1)',
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              pointBackgroundColor: '#fff',
              pointBorderColor: 'rgba(75, 192, 192, 1)',
              pointHoverRadius: 6,
              pointRadius: 5,
              tension: 0.4,
              fill: true,
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };

    fetchCounts();
  }, []);

  const StatisticsOver = {
			exportEnabled: true,
			animationEnabled: true,
			title: {
				text: "Statistics Overview"
			},
			data: [{
				type: "pie",
				startAngle: 75,
				toolTipContent: "<b>{label}</b>: {y}%",
				showInLegend: "true",
				legendText: "{label}",
				indexLabelFontSize: 16,
				indexLabel: "{label} - {y}%",
				dataPoints: [
					{ y: 18, label: "Total Users" },
					{ y: 49, label: "Total Appointments" },
					{ y: 9, label: "Total Orders" },
					{ y: 5, label: "Total Providers" },
				
				]
			}]
		}

    const MonthlySales = {
			animationEnabled: true,
			title:{
				text: "Monthly Sales - 2025"
			},
			axisX: {
				valueFormatString: "MMM"
			},
			axisY: {
				title: "Sales (in USD)",
				prefix: "$"
			},
			data: [{
				yValueFormatString: "$#,###",
				xValueFormatString: "MMMM",
				type: "spline",
				dataPoints: [
					{ x: new Date(2025, 0), y: 25060 },
					{ x: new Date(2025, 1), y: 27980 },
					{ x: new Date(2025, 2), y: 42800 },
					{ x: new Date(2025, 3), y: 32400 },
					{ x: new Date(2025, 4), y: 35260 },
					{ x: new Date(2025, 5), y: 33900 },
					{ x: new Date(2025, 6), y: 40000 },
					{ x: new Date(2025, 7), y: 52500 },
					{ x: new Date(2025, 8), y: 32300 },
					{ x: new Date(2025, 9), y: 42000 },
					{ x: new Date(2025, 10), y: 37160 },
					{ x: new Date(2025, 11), y: 38400 }
				]
			}]
		}

  return (
    <div className="d-flex h-100">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{  width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col md={3}>
              <StatsCard title="Total Users" value={stats.totalUsers} icon="user" color="warning" />
            </Col>
            <Col md={3}>
              <StatsCard title="Total Appointments" value={stats.totalAppointments} icon="clock" color="info" />
            </Col>
            <Col md={3}>
              <StatsCard title="Total Orders" value={stats.totalOrders} icon="cloud-download" color="success" />
            </Col>
            <Col md={3}>
              <StatsCard title="Total Providers" value={stats.totalProviders} icon="chat" color="danger" />
            </Col>
          </Row>

          {/* Line Chart Section */}
          <Row className="mt-4">
           
            <Col md={4} lg={4} xl={4}>
             <CanvasJSChart options = {StatisticsOver}/>
             </Col>
             <Col md={8} lg={8} xl={8}>
             <CanvasJSChart options = {MonthlySales}/>
             </Col>

            {/*  <Col md={6} lg={6} xl={6}>
              <h5 className="text-center">Statistics Overview</h5>
              {chartData && (
                <div style={{ height: '350px' }}>
                  <Line
                    data={chartData}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false, // This makes the chart take up the container's full height
                      plugins: {
                        legend: {
                          position: 'top',
                        },
                        title: {
                          display: true,
                          text: 'Counts of Users, Appointments, Orders, and Providers',
                        },
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                        },
                      },
                    }}
                  />
                </div>
              )}
            </Col> */}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Dashboard;
